import React from "react";
import { STRINGS } from "../../../../strings";
import { translate } from "../../../../translate";
import { CardButton } from "../../../CardButton/CardButton";
import { AppCardFooter } from "../../../Generic/AppCard";
import AppSwitch from "../../../Generic/AppSwitch/AppSwitch";
import Flex from "../../../Generic/Flex";

interface Props {
  isEditable: boolean;
  isProfileSync: boolean;
  onRequestSave: () => void;
  onRequestToggleEdit: (editMode: boolean) => void;
  onRequestDelete: () => void;
  onClickProfileSync: () => void;
}

const MedicationCardFooter = (props: Props) => {
  return (
    <AppCardFooter>
      <Flex className="MedicationCardControls" direction="column">
        <Flex className="UpdatePatientProfileControls" justifyContent="space-between">
          <span className="leading">Update to patient profile</span>
          <AppSwitch checked={props.isProfileSync} onChange={props.onClickProfileSync} />
        </Flex>
        <Flex justifyContent="space-between">
          <CardButton onClick={() => props.onRequestDelete()} color="danger" variation="outline">
            {translate(STRINGS.DELETE)}
          </CardButton>
          {props.isEditable ? (
            <>
              <CardButton
                onClick={() => {
                  props.onRequestToggleEdit(false);
                }}
                variation="outline"
              >
                {translate(STRINGS.CANCEL)}
              </CardButton>
              <CardButton
                onClick={() => {
                  props.onRequestToggleEdit(false);
                  props.onRequestSave();
                }}
                variation="filled"
              >
                {translate(STRINGS.SAVE)}
              </CardButton>
            </>
          ) : (
            <CardButton onClick={() => props.onRequestToggleEdit(true)} variation="filled">
              {translate(STRINGS.EDIT)}
            </CardButton>
          )}
        </Flex>
      </Flex>
    </AppCardFooter>
  );
};

export default React.memo(MedicationCardFooter);
